import ordersToClose from './ordersToClose';
import shifts from './shifts';
import orders from './orders';

export default { ordersToClose, shifts, orders };
